import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'lib-a4-preview-card',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, DragDropModule],
  host: {
    'style': 'display: block;'
  },
  template: `
    <div class="preview-card-wrapper" [class.stacked-mode]="secondaryThumbnailUrl">
      <div class="preview-page" [class.add-card]="isAddCard" [class.is-landscape]="orientation === 'l'">
        <!-- Drag Handle -->
        <div class="drag-handle" *ngIf="allowReorder && !isAddCard" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </div>

        <!-- Main Content -->
        <div class="card-content" 
             [class.add-content]="isAddCard" 
             (click)="onCardClick()"
             (keydown.enter)="onCardClick()"
             tabindex="0"
             role="button">
          <ng-container *ngIf="!isAddCard; else addState">
            <div class="skeleton-loader" *ngIf="!thumbnailUrl && !isAddCard"></div>
            
            <div class="thumbnail-stack" *ngIf="secondaryThumbnailUrl">
                <img [src]="secondaryThumbnailUrl" class="secondary-thumb" alt="file preview last page">
            </div>
            <img *ngIf="thumbnailUrl" [src]="thumbnailUrl" [style.transform]="'rotate(' + rotation + 'deg)'" alt="file preview">
            
            <div class="page-badge" *ngIf="pageNumber || title">
              {{ title ? title : (isPageCount ? pageNumber + ' Pages' : 'Page ' + pageNumber) }}
            </div>
          </ng-container>

          <ng-template #addState>
            <mat-icon>{{ addIcon }}</mat-icon>
            <span class="add-label">{{ addLabel }}</span>
          </ng-template>
        </div>

        <!-- Actions Overlay -->
        <div class="card-actions" *ngIf="!isAddCard && showActions">
          <button mat-icon-button class="action-btn" (click)="onRotate($event)" title="Rotate Clockwise" *ngIf="canRotate">
            <mat-icon>rotate_right</mat-icon>
          </button>
          <button mat-icon-button class="action-btn delete-btn" (click)="onDelete($event)" title="Remove File" *ngIf="canDelete">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrl: './file-preview.css'
})
export class A4PreviewCard {
  @Input() thumbnailUrl?: string | SafeUrl;
  @Input() secondaryThumbnailUrl?: string | SafeUrl;
  @Input() rotation = 0;
  @Input() pageNumber?: number;
  @Input() title?: string;
  @Input() showActions = true;
  @Input() canRotate = true;
  @Input() canDelete = true;
  @Input() isAddCard = false;
  @Input() allowReorder = true;
  @Input() addIcon = 'add_photo_alternate';
  @Input() addLabel = 'Add Files';
  @Input() orientation: 'p' | 'l' = 'p';
  @Input() isPageCount = false;

  @Output() rotate = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
  @Output() cardClick = new EventEmitter<void>();

  onRotate(event: Event) {
    event.stopPropagation();
    this.rotate.emit();
  }

  onDelete(event: Event) {
    event.stopPropagation();
    this.remove.emit();
  }

  onCardClick() {
    this.cardClick.emit();
  }
}
